import { useState, useEffect, useCallback } from 'react';
import { isAuthenticated, logout, verifyToken, getAuthHeaders, getToken } from '../utils/auth';

/**
 * Custom hook for admin authentication logic
 * Reduces duplicate auth code across admin components
 */
export const useAdminAuth = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Check authentication on mount
  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      setIsCheckingAuth(true);
      if (isAuthenticated()) {
        const valid = await verifyToken();
        if (isMounted) {
          if (valid) {
            setIsAuth(true);
          } else {
            logout();
            setIsAuth(false);
          }
        }
      }
      if (isMounted) {
        setIsCheckingAuth(false);
      }
    };
    checkAuth();
    return () => { isMounted = false; };
  }, []);

  const handleLogin = useCallback(() => {
    setIsAuth(true);
  }, []);

  const handleLogout = useCallback(() => {
    logout();
    setIsAuth(false);
  }, []);

  // Get auth header for API calls
  const getAuthHeader = useCallback(() => {
    const token = getToken();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }, []);

  return {
    isAuth,
    isCheckingAuth,
    handleLogin,
    handleLogout,
    getAuthHeader,
    getAuthHeaders
  };
};

export default useAdminAuth;
